import { render, staticRenderFns } from "./AdditionalHealthInsurancePlan.vue?vue&type=template&id=6dc52530&scoped=true"
import script from "./AdditionalHealthInsurancePlan.vue?vue&type=script&lang=js"
export * from "./AdditionalHealthInsurancePlan.vue?vue&type=script&lang=js"
import style0 from "./AdditionalHealthInsurancePlan.vue?vue&type=style&index=0&id=6dc52530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc52530",
  null
  
)

export default component.exports